import { config } from '.';
import urljoin from 'url-join';
import { get, has, flatten, upperFirst, isString, isEmpty } from 'lodash-es';
export function createHtmlErrorMessage(error, customHeading = '') {
    const errorLines = [];
    if (customHeading) {
        errorLines.push(customHeading);
    }
    if (has(error, 'response.data.message') &&
        error.response.data.message &&
        isString(error.response.data.message)) {
        errorLines.push(error.response.data.message);
    }
    if (has(error, 'response.status') &&
        error.response.status >= 400 &&
        (error.response.status !== 422 || !has(error, 'response.data.errors'))) {
        errorLines.push(`[${error.response.status}] ${error.response.statusText}`);
    }
    if (has(error, 'response.data.errors') &&
        !isEmpty(error.response.data.errors)) {
        errorLines.push((() => {
            const errors = error.response.data.errors;
            Object.keys(errors).forEach((key) => {
                errors[key] = errors[key].map((error) => upperFirst(error));
            });
            return ('<ul><li>' +
                flatten(Object.keys(errors).map((key) => errors[key])).join('</li><li>') +
                '</li></ul>');
        })());
    }
    const heading = errorLines.shift();
    return (`<b>${heading}</b>` +
        (!isEmpty(errorLines) ? '<br/>' + errorLines.join('<br/>') : ''));
}
export function route(name, ...parameters) {
    let url = config(`paths.${name}`);
    if (!url) {
        url = config(`routes.${name}`);
    }
    if (!url) {
        return '';
    }
    for (let index = 0; index < parameters.length; index++) {
        const parameter = get(parameters[index], 'id', parameters[index]);
        url = url.replace(/[\%|{][-\w]*[\%|}]/, parameter);
    }
    return url;
}
export function url(endpoint) {
    if (config('app.url')) {
        return urljoin(config('app.url'), endpoint);
    }
    return '';
}
export function assetUrl(endpoint) {
    if (config('assets.uri')) {
        return urljoin(config('assets.uri'), endpoint);
    }
    return '';
}
